export const calendarMonth_August = "Tpa";
export default {calendarMonth_August};